import axios from 'axios';
import md5 from 'crypto-js/md5';
import { Message } from 'element-ui';

const appKey = window.location.hostname.split('.')[0];
axios.defaults.headers.common['X-CUSTOM-HUASI-APPKEY'] = appKey;
axios.defaults.timeout = 60000;

// 请求拦截器
axios.interceptors.request.use((config) => {
  const timestamp = Date.now();
  const secret = 'HUASI_SECRET';
  const token = md5([appKey, timestamp].join(secret)).toString().toUpperCase();
  config.headers['X-CUSTOM-HUASI-TIMESTAMP'] = timestamp;
  config.headers['X-CUSTOM-HUASI-TOKEN'] = token;
  return config;
}, (error) => {
  return Promise.reject(error);
});

// 响应拦截器
axios.interceptors.response.use((response) => {
  if (response.data.msg === 'DATA_MISSING') {
    response.data.msg = '网络无回复，请稍后重试';
  }
  return response;
}, (error) => {
  if (error.code === 'ECONNABORTED') {
    return Promise.reject(new Error('请求超时'));
  }
  if (error.response.status === 403) {
    Message({ message: error.response.data.msg, type: 'error', duration: 5000 });
  }
  return Promise.reject(error);
});

export * from './projects';
export * from './devices';
export * from './deviceSources';
export * from './collections';
export * from './branches';
export * from './admin';
export * from './metaData';
export * from './misc';
export * from './clusters';
export * from './jitters';
export * from './report';
export * from './push';
export * from './collectionInsertLog';
export * from './dataJumps';

